import { App } from 'antd';
import { http } from 'services/http';
import { TRANSPORT_COST_PER_KM_GET } from 'api/query-keys.ts';
import type { TUpdateTransportCostPerKmReq } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';

export const useUpdateTransportCostPerKm = (costPerKmId: number) => {
  const { message } = App.useApp();

  return useMutationBase<void, unknown, TUpdateTransportCostPerKmReq>({
    mutationFn: async (variables) => {
      await http.patch(`/v1/transports/cost-per-km/${costPerKmId}`, variables);
    },
    invalidateCallback: () => [[TRANSPORT_COST_PER_KM_GET]],
    onSuccess: () => {
      message.success('Cost updated successfully');
    },
  });
};
